import { useState } from 'react';
import { Button, ButtonGroup } from '@lendi-ui/button';
import Modal from '@lendi-ui/modal';
import { RadioGroup } from '@lendi-ui/radio';
import { Body } from '@lendi-ui/typography';

import { ApplicantEntityIndex } from '@funnels/types';

import { Link } from '../../style';

interface AddressCopierProps extends ApplicantEntityIndex {
  linkSize?: 'lg' | 'md' | 'sm' | 'xs' | 'xxs';
  addresses: string[];
  currentPostSettlementAddress: string;
  setPostSettlementAddress: (address: string) => void;
}

export const AddressCopier = ({
  addresses,
  currentPostSettlementAddress,
  setPostSettlementAddress,
  linkSize = 'sm',
}: AddressCopierProps) => {
  const [selectedAddress, setSelectedAddress] = useState<string | undefined>(currentPostSettlementAddress);
  const [modalVisibility, setModalVisibility] = useState(false);

  return (
    <>
      <Link
        size={linkSize}
        onClick={() => {
          setModalVisibility(!modalVisibility);
        }}
      >
        Use an existing address
      </Link>
      <Modal
        role="dialog"
        isVisible={modalVisibility}
        size="lg"
        isHeaderFixed
        onHide={() => {
          setModalVisibility(!modalVisibility);
        }}
      >
        <Modal.Header title="Use an existing address" />
        <Modal.Content>
          <Body size="md">Select from one of the following addresses</Body>
          <RadioGroup
            onChange={(e) => setSelectedAddress(e.target.value as string)}
            selectedValue={selectedAddress as string}
          >
            {addresses.map((address) => (
              <RadioGroup.Radio key={address} label={address} value={address} />
            ))}
          </RadioGroup>
        </Modal.Content>
        <Modal.Footer>
          <ButtonGroup isFullWidth size="md">
            <Button
              variant="primary"
              isFullWidth
              isDisabled={!selectedAddress}
              onClick={() => {
                setPostSettlementAddress(selectedAddress!);
                setModalVisibility(!modalVisibility);
              }}
            >
              Done
            </Button>
            <Button
              variant="secondary"
              isFullWidth
              onClick={() => {
                setModalVisibility(!modalVisibility);
              }}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    </>
  );
};
